<template>
  <tr>
    <td class="align-middle">{{ airportData.name }}</td>
    <td class="align-middle" style="width: 80px;">{{ airportData.icao }}</td>
    <td class="align-middle" style="width: 80px;">{{ airportData.iata }}</td>
    <td class="align-middle" style="width: 80px;">{{ airportData.warnings }}</td>
    <td style="width: 160px;" class="align-middle">
      <span class="text-primary" v-if="airportData.is_default">Preferred airport</span>
      <a href="#" class="text-secondary" v-else @click.prevent="setDefaultAirport">
        <template v-if="!defaultInProgress">Set as preferred</template>
        <template v-else>Saving...</template>
      </a>
    </td>
    <td style="width: 60px;" class="align-middle">
      <d-button
        theme="danger"
        :disabled="removeInProgress"
        @click.prevent="removeAirport"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'airports-list-item',
  props: {
    airportData: {
      type: Object,
      default: () => ({}),
      required: true
    },
    referenceId: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data () {
    return {
      defaultInProgress: false,
      removeInProgress: false
    };
  },
  methods: {
    removeAirport () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/handlers/delete-airport/' + parseInt(this.referenceId, 10),
        idKey: 'airport_id',
        idValue: parseInt(this.airportData.id, 10),
        successTitle: 'Agent\'s Airport removed',
        successText: 'The selected agent\'s airport has been removed',
        confirmTitle: 'Do you really want to remove this agent\'s airport?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('airports-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    setDefaultAirport () {
      if (this.defaultInProgress) {
        return;
      }

      this.defaultInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/handlers/set-default-airport/' + parseInt(this.referenceId, 10),
        formData: {
          airport_id: parseInt(this.airportData.id, 10)
        },
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during default airport change. Please try again.',
        successAction: () => {
          this.defaultInProgress = false;
          this.$bus.$emit('airports-list-reload');
        }
      });
    }
  }
};
</script>
